module.exports = __webpack_public_path__ + "static/call-to-action-e4a898273368e8f95c949e4139302dc5.png";